import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

// ui
import Modal from '../../../components/feedback/modal'
import ModalSelectMedia from './modal_select_media'
import ModalSelectObject from './modal_select_object'
import ModalSelectEvent from './modal_select_event'
import ModalSelectReport from './modal_select_report_lower_tier'

// subcomponent 
import ReportInfoForm from './report_info_form'
import ReportInfoView from './report_info_view'

class ModalReportInfo extends Component{

    constructor(props){
        super(props)
        this.state = {
            editorText: ''
        }
    }

    _handleOK = () => {
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    _handleEditorChange = value => {
        value = String(value)
        this.setState({editorText: value})
    }

    render(){
        const { visible, mode, report } = this.props
        return (
            <Modal
                visible={visible}
                title="Chi tiết báo cáo"   
                onOk={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                centered
                width={1000}
                footer={
                    null
                }
            >
                
                {
                    (report.fid === 0 || report.status !== 'Sent') ? <ReportInfoForm onOk = {() => this._handleOK()} onCancel={() => this._handleCancel()} />
                    : <ReportInfoView />
                }

                <ModalSelectMedia />
                <ModalSelectObject />
                <ModalSelectEvent />
                <ModalSelectReport />
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        visible: state.qbreport.modalReportInfoState,
        mode: state.qbreport.mode_modal_report_info,
        report: state.qbreport.current_report
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(ReportActions.action.dismissModalReportInfo())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalReportInfo)